export const DropdownRole = {
  Owner: 'Owner',
  Editor: 'Editor',
  Viewer: 'Viewer',
}
